import { render, staticRenderFns } from "./SyncCustomers.vue?vue&type=template&id=c0ff4330"
import script from "./SyncCustomers.vue?vue&type=script&lang=js"
export * from "./SyncCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports